import React from 'react';
import { Quote } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  role: string;
  quote: string;
}
export function TestimonialCard({
  name,
  role,
  quote
}: TestimonialCardProps) {
  return <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100 flex flex-col h-full" data-id="element-27">
      <Quote className="h-8 w-8 text-yellow-400 mb-4" data-id="element-28" />
      <p className="text-gray-700 italic text-lg mb-6 flex-grow" data-id="element-29">"{quote}"</p>
      <div className="mt-auto border-t pt-4 border-gray-100" data-id="element-30">
        <p className="font-bold text-gray-900" data-id="element-31">{name}</p>
        <p className="text-sm text-gray-500" data-id="element-32">{role}</p>
      </div>
    </div>;
}